import {Stage} from './stage';
import {SystemType} from "./enums/system.type";

export class Board {
  ID: string;
  NAME: string;
  DATE_CREATED: Date;
  BOARD_COLUMNS: BoardColumn[];
  IS_DEFAULT: boolean;
  ASK_MODAL: boolean;
  SHARED: boolean;
// this field is for rename board action
  EDITABLE: boolean;
  IS_WIDE: boolean;
  TYPE: SystemType;
  static parse(json: any): Board {
    if (json) {
      const f = new Board();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.DATE_CREATED = json.DATE_CREATED;
      f.BOARD_COLUMNS = BoardColumn.parseArray(json.BOARD_COLUMNS);
      f.IS_DEFAULT = json.IS_DEFAULT;
      f.ASK_MODAL = json.ASK_MODAL;
      f.EDITABLE = false;
      f.IS_WIDE = json.IS_WIDE;
      f.SHARED = json.SHARED;
      if(json.TYPE)
        f.TYPE = SystemType[<string>json.TYPE];
      return f;
    } else return null;
  }

  static parseArray(json: any[]): Board[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Board.parse(j));

    return arr;
  }
}

export class BoardColumn {
  ID: string;
  NAME: string;
  DATE_CREATED: Date;
  ORDER: number;
  DESCRIPTION: string;
  STAGES: BoardColumnStages[] = [];
  ASSIGN_STAGE: Stage[] = [];
  // these fields is for drag drop action on Board
  EDITABLE: boolean;
  SHOW_ME: boolean;

  // Helper
  REPORT_LIMIT: number;

  static parse(json: any): BoardColumn {
    if (json) {
      const f = new BoardColumn();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.DATE_CREATED = json.DATE_CREATED;
      f.ORDER = json.ORDER;
      f.DESCRIPTION = json.DESCRIPTION;
      f.EDITABLE = false;
      if(json.SHOW_ME)
        f.SHOW_ME = json.SHOW_ME;
      if(json.STAGES)
        f.STAGES = BoardColumnStages.parseArray(json.STAGES);

      if(f.STAGES?.length > 0){
        f.ASSIGN_STAGE = f.STAGES.map(s =>s.STAGE);
      }
      return f;
    } else return null;
  }

  static parseArray(json: any[]): BoardColumn[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(BoardColumn.parse(j));

    return arr;
  }
}


export class BoardColumnStages {
  ID: String;
  STAGE: Stage

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.STAGE)
      this.STAGE = Stage.parse(value.STAGE);
  }

  static parseArray(json: any[]): BoardColumnStages[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new BoardColumnStages(j));
        }
      }
    }

    return arr;
  }
}
